import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import loadingSlice, { getLoader } from '../../../store/slices/loading.slice';

import { Icon } from '../index';
import './ScreenLoader.scss';

interface Props {
  isLoading?: boolean;
}

const ScreenLoader: React.FC<Props> = () => {
  const { loading } = useSelector(getLoader);
  const dispatch = useDispatch();

  const [hide, setHide] = useState(loading);

  useEffect(() => {
    setHide(loading);
    const timeout = setTimeout(() => {
      setHide(false);
      dispatch(loadingSlice.actions.setLoading(false));
    }, 1000);
    return () => clearTimeout(timeout);
  }, [loading]);

  return (
    <div className={`screen${!hide ? ' hide' : ''}`}>
      <Icon imgPath="/images/spin.svg" className="spin__loader" />
    </div>
  );
};

export default ScreenLoader;
